module.exports = __webpack_public_path__ + "img/1fie-j-bene'se'kwell.05f53b67.jpg";